import { formatMoney } from "@faire/web--source/common/money";
import React from "react";

import { ProductTileInfo } from "@faire/retailer/features/MarketplaceItems/ProductTileInfo";
import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer/lib/isLoggedInRetailer";
import { showProductPromotions } from "@faire/retailer/lib/showProductPromotions";
import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";
import { Price } from "@faire/retailer/views/product/ProductDetails/Price/Price";
import { PRICE_TEXT_SURFACE } from "@faire/retailer/views/product/ProductDetails/Price/PriceProps";

interface IPriceTextProps {
  productTile?: Pick<
    ProductTileInfo,
    | "min_option_wholesale_promo_price"
    | "min_option_wholesale_price"
    | "min_option_retail_price"
  >;
}
/**
 * TODO:@z27fangFaire This component should be eliminated once we have all product tile to be composable tiles.
 */
export const PriceText: React.FC<IPriceTextProps> = ({ productTile }) => {
  const { isUK } = useRetailerStore(["isUK"]);
  const isLoggedIn = useIsLoggedInRetailerOrBrandPreview();
  if (!productTile) {
    return null;
  }
  const productLevelPromotion = productTile?.min_option_wholesale_promo_price;
  const originalPrice = productTile?.min_option_wholesale_price
    ? formatMoney({
        money: productTile.min_option_wholesale_price,
        omitCentsIfZero: true,
      })
    : "";

  const wholesalePrice = productTile?.min_option_wholesale_promo_price
    ?.discounted_item_price
    ? formatMoney({
        money:
          productTile.min_option_wholesale_promo_price.discounted_item_price,
        omitCentsIfZero: true,
      })
    : originalPrice;

  const retailPrice = productTile?.min_option_retail_price
    ? formatMoney({
        money: productTile.min_option_retail_price,
        omitCentsIfZero: true,
      })
    : "";

  return (
    <Price
      isUKRetailer={isUK}
      isLoggedInOrBrandPreview={isLoggedIn}
      showProductPromotions={showProductPromotions(productLevelPromotion)}
      originalPrice={originalPrice}
      wholesalePrice={wholesalePrice}
      retailPrice={retailPrice}
      small
      isTilePricing
      priceTextSurface={PRICE_TEXT_SURFACE.PRODUCT_TILE}
    />
  );
};
